import { useState } from 'react';
import { Download, Loader2 } from 'lucide-react';
import { api } from '../api';
import { guardarArchivo } from './descarga';

// «LLÉVATE TODO LO TUYO» · criterio 5.5 del Bloque 5.
//
// Va en «Este servidor», junto a las copias, porque es de la misma
// familia: son las dos cosas que responden a «¿y si un día me quiero
// ir?». Y va con su explicación delante, porque un botón que descarga la
// empresa entera sin decir qué trae asusta más que tranquiliza — que es
// justo lo contrario de lo que busca.
export default function ExportarTodo() {
  const [yendo, setYendo] = useState(false);
  const [error, setError] = useState('');
  const [hecho, setHecho] = useState(false);

  const bajar = async () => {
    setYendo(true); setError(''); setHecho(false);
    try {
      const blob = await api.descargar('/exportar/todo', {});
      guardarArchivo(blob, 'tego-todos-mis-datos.zip');
      setHecho(true);
    } catch (e) {
      setError(e.message);
    } finally {
      setYendo(false);
    }
  };

  return (
    <section className="rounded-xl border border-gray-200 p-4">
      <h2 className="font-semibold text-gray-900">Llévate todos tus datos</h2>
      <p className="mt-1 text-sm text-gray-600">
        Un solo archivo con <strong>toda</strong> la información de tu
        empresa: productos, existencias, movimientos, clientes, personas,
        documentos y los archivos que has subido.
      </p>
      <p className="mt-2 text-sm text-gray-500">
        Viene en hojas de cálculo que abre Excel o cualquier programa
        parecido, y trae un LEEME que explica qué es cada cosa.{' '}
        <strong>No hace falta pedir permiso a nadie ni pagar nada</strong>:
        son tuyos, y funciona igual aunque tu suscripción esté vencida.
      </p>

      <button
        type="button"
        onClick={bajar}
        disabled={yendo}
        className="mt-3 inline-flex items-center gap-2 rounded-lg
                   bg-[var(--color-marca)] px-3 py-2 text-sm font-semibold
                   text-white disabled:opacity-60"
      >
        {yendo
          ? <><Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" /> Preparando el archivo…</>
          : <><Download className="h-4 w-4" aria-hidden="true" /> Descargar todo</>}
      </button>

      {/* PUEDE TARDAR, Y SE DICE MIENTRAS TARDA. Con un catálogo grande
          esto son varios segundos sin nada en pantalla, y ahí es donde
          alguien vuelve a pulsar y se lleva dos archivos. */}
      {yendo && (
        <p className="mt-2 text-sm text-gray-500">
          Con muchos productos puede tardar un poco. No cierres esta
          pantalla; el archivo se guarda solo cuando esté listo.
        </p>
      )}
      {hecho && !yendo && (
        <p className="mt-2 text-sm font-semibold text-green-700">
          Listo, se descargó. Ábrelo y empieza por el archivo LEEME.
        </p>
      )}
      {error && (
        <p className="mt-2 text-sm text-red-700">{error}</p>
      )}
    </section>
  );
}
